// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"268":"Home","438":"Login"}[chunkId] || chunkId) + "." + {"268":"6c8413a4","438":"e90eb41f","479":"56329e32","612":"5e53a44c"}[chunkId] + ".chunk.js";
};